export enum AutoExportDataset {
  REVENUE_TOTAL = "REVENUE_TOTAL",
  REVENUE_BY_SERVICE = "REVENUE_BY_SERVICE",
  REVENUE_AVG_CHECK = "REVENUE_AVG_CHECK",
  REVENUE_DISTRIBUTION = "REVENUE_DISTRIBUTION",
  SERVICES_USAGE = "SERVICES_USAGE",
  OPERATIONS_TOTAL_REQUESTS = "OPERATIONS_TOTAL_REQUESTS",
  REVIEWS_RATINGS = "REVIEWS_RATINGS",
  TEAMS_ACTIVITY = "TEAMS_ACTIVITY",
  TENANT_REVENUE = "TENANT_REVENUE",
  TENANT_SERVICES = "TENANT_SERVICES",
  TENANT_OFFERS = "TENANT_OFFERS",
  TENANT_REVIEWS = "TENANT_REVIEWS",
  TENANT_OPERATIONS = "TENANT_OPERATIONS",
  TENANT_TEAMS = "TENANT_TEAMS",
}

export enum AutoExportFrequency {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
}

export enum AutoExportRunStatus {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export enum ExportFormat {
  CSV = "CSV",
  XLSX = "XLSX",
}

export interface AutoExportSchedule {
  id: string;
  tenantId: string;
  hotelId: string | null;
  createdById: string;
  createdByRoles: string[];
  title: string;
  description: string | null;
  dataset: AutoExportDataset;
  format: ExportFormat;
  recipients: string[];
  frequency: AutoExportFrequency;
  sendHourUtc: number;
  windowDays: number;
  enabled: boolean;
  nextRunAt: string;
  lastRunAt: string | null;
  lastRunStatus: AutoExportRunStatus | null;
  lastRunError: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedAutoExportSchedules {
  data: AutoExportSchedule[];
  total: number;
}

export interface ListAutoExportSchedulesQuery {
  hotelId?: string;
  dataset?: AutoExportDataset;
  enabled?: boolean;
  skip?: number;
  take?: number;
}

export interface CreateAutoExportScheduleBody {
  dataset: AutoExportDataset;
  hotelId?: string;
  title: string;
  description?: string;
  format?: ExportFormat;
  recipients?: string[];
  frequency: AutoExportFrequency;
  sendHourUtc?: number;
}

export type UpdateAutoExportScheduleBody =
  Partial<CreateAutoExportScheduleBody>;
